import React, { useState } from 'react';
import axios from 'axios';
import './PostDisplay.css';

const PostDisplay = ({ post }) => {
  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(post?.likes?.length || 0);
  const [showComments, setShowComments] = useState(false);
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState(post?.comments || []);

  if (!post) return null;

  const handleLike = async () => {
    try {
      const response = await axios.post(
        `/api/posts/${post._id}/like`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      if (response.data.success) {
        setLiked(response.data.liked);
        setLikesCount(response.data.likesCount);
      }
    } catch (error) {
      console.error('Error liking post:', error);
    }
  };

  const handleComment = async () => {
    if (!comment.trim()) return;
    
    try {
      const response = await axios.post(
        `/api/posts/${post._id}/comment`,
        { content: comment },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      if (response.data.success) {
        setComments([...comments, response.data.comment]);
        setComment('');
      }
    } catch (error) {
      console.error('Error commenting:', error);
    }
  };

  return (
    <div className="post-display">
      <div className="post-header">
        <div className="post-user-info">
          <div className="post-avatar">
            {post.user?.username?.[0]?.toUpperCase() || 'U'}
          </div>
          <div className="post-user-details">
            <span className="post-username">{post.user?.username || 'Anonymous'}</span>
            <span className="post-time">
              {new Date(post.created || post.createdAt).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
      
      <div className="post-content">
        <p>{post.content}</p>
      </div>
      
      <div className="post-actions">
        <button 
          className={`action-btn ${liked ? 'liked' : ''}`} 
          onClick={handleLike}
        >
          <i className={`${liked ? 'fas' : 'far'} fa-heart`}></i>
          <span>{likesCount}</span>
        </button>
        
        <button 
          className="action-btn" 
          onClick={() => setShowComments(!showComments)}
        >
          <i className="far fa-comment"></i>
          <span>{comments.length}</span>
        </button>
        
        <button className="action-btn">
          <i className="fas fa-share"></i>
        </button>
      </div>
      
      {showComments && (
        <div className="post-comments">
          <div className="comments-list">
            {comments.map((c, idx) => (
              <div key={idx} className="comment">
                <span className="comment-user">{c.user?.username || 'Anonymous'}:</span>
                <span className="comment-text">{c.content}</span>
              </div>
            ))}
          </div>
          
          <div className="comment-input">
            <input
              type="text"
              placeholder="Add a comment..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleComment()}
            />
            <button onClick={handleComment}>Post</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostDisplay;